module.exports = __webpack_public_path__ + "img/FAQ-2.21fdde3b.gif";